import styled from 'styled-components';

export const PricingOptionStyled = styled.div`
  .pricing-item {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .pricing-content {
      height: 200px;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .old-price {
        text-decoration: line-through;
        color: rgb(228, 77, 84);
      }

      .pricing-content-button {
        margin-top: auto;
        .Polaris-Button {
          min-height: 40px;
        }
      }
    }

    .pricing-features {
      display: flex;
      flex-direction: column;
      gap: 0.6rem;

      .icon-feature-check .Polaris-Icon__Svg {
        color: rgba(72, 176, 44, 1);
      }
    }
  }
`;
